import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTypedSelector } from 'src/redux/utils';
import MaintenanceModal from '../RentOutProvider/MaintenanceModal';
import ConnectWalletModal from './ConnectWalletModal';
import TransactionConfirmModal from './TransactionConfirmModal';
import TransactionSuccessModal from './TransactionSuccessModal';
import useCheckTradingEvent from 'src/Pages/TradingEvent/useCheckTradingEvent';
import { RouteName } from 'src/routes/config';
import { navigateToConnectWallet } from 'src/utils/navigate';
import WalletConnectConfirmProvider from 'src/Components/WalletConnectConfirmProvider';
import { TestableProvider } from '@wolffun/testable-id';
var RentModalName;

(function (RentModalName) {
  RentModalName["CONNECT_WALLET"] = "connect_wallet";
  RentModalName["TRANSACTION_DETAIL"] = "transaction_detail";
  RentModalName["TRANSACTION_SUCCESS"] = "transaction_success";
  RentModalName["MAINTENANCE"] = "maintenance";
})(RentModalName || (RentModalName = {}));

const noop = () => {};

const RentContext = /*#__PURE__*/React.createContext({
  startRenting: () => noop,
  openModal: noop,
  closeModal: noop,
  showMaintenance: noop
});

const CheckoutProvider = ({
  children
}) => {
  const history = useHistory();
  const [hero, setHero] = React.useState(null);
  const [modal, setModal] = React.useState(null);
  const [successHero, setSuccessHero] = React.useState();
  const heroDescriptionConfigs = useTypedSelector(state => state.heroDescriptionConfigs.description);
  const {
    hasEvent: hasSpecialEvent,
    heroEvent
  } = useCheckTradingEvent({
    heroTrophyClass: hero === null || hero === void 0 ? void 0 : hero.hero.trophy,
    heroLevel: hero === null || hero === void 0 ? void 0 : hero.hero.level,
    heroClass: heroDescriptionConfigs === null || heroDescriptionConfigs === void 0 ? void 0 : heroDescriptionConfigs[(hero === null || hero === void 0 ? void 0 : hero.heroType.id) || 0].role,
    skinRarity: hero === null || hero === void 0 ? void 0 : hero.hero.skinRarity
  });
  const startRenting = React.useCallback(hero => {
    setHero(hero);
    setModal(RentModalName.CONNECT_WALLET);
  }, []);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setHero(null);
    setModal(null);
  }, []);
  const showMaintenance = React.useCallback(() => {
    setModal(RentModalName.MAINTENANCE);
  }, []);
  const context = React.useMemo(() => {
    return {
      hero: hero || undefined,
      modal: modal || undefined,
      startRenting,
      openModal,
      closeModal,
      showMaintenance
    };
  }, [hero, modal]); // Auto open the TransactionConfirm if the user is already signed in

  const signedIn = useTypedSelector(state => !!state.userSignIn.accessToken);
  React.useEffect(() => {
    if (signedIn && modal === 'connect_wallet') {
      if (hero && hero.hero.battleCapTHC >= hero.hero.totalBattleCapTHC * 0.8) openModal(RentModalName.TRANSACTION_DETAIL);else openModal(RentModalName.TRANSACTION_DETAIL);
    }
  }, [signedIn, modal]); // Render the current modal

  const renderModal = () => {
    switch (modal) {
      case RentModalName.CONNECT_WALLET:
        return /*#__PURE__*/React.createElement(ConnectWalletModal, {
          onClose: () => {
            closeModal();
          },
          onConnectButtonPressed: () => {
            navigateToConnectWallet({
              redirectTo: hero ? `${RouteName.HeroDetail}/${hero.hero.id}` : ''
            });
          }
        });

      case RentModalName.TRANSACTION_DETAIL:
        return hero ? /*#__PURE__*/React.createElement(TransactionConfirmModal, {
          hero: hero,
          onRentCompleted: (nftHero, balance) => {
            setSuccessHero({
              hero: nftHero,
              balance: balance
            });
            openModal(RentModalName.TRANSACTION_SUCCESS);
          },
          onClose: () => {
            closeModal();
          }
        }) : null;

      case RentModalName.TRANSACTION_SUCCESS:
        return !!successHero && /*#__PURE__*/React.createElement(TransactionSuccessModal, {
          hero: successHero.hero,
          balance: successHero.balance,
          hasSpecialEvent: hasSpecialEvent,
          heroEvent: heroEvent,
          onClose: () => {
            closeModal();
            history.push('/rental');
          }
        });

      case RentModalName.MAINTENANCE:
        return /*#__PURE__*/React.createElement(MaintenanceModal, {
          onClose: () => {
            closeModal();
          }
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(WalletConnectConfirmProvider, null, /*#__PURE__*/React.createElement(RentContext.Provider, {
    value: context
  }, children, /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "rent"
  }, renderModal())));
};

export const useRentHero = () => {
  const {
    startRenting,
    showMaintenance
  } = React.useContext(RentContext);
  return {
    startRenting,
    showMaintenance
  };
};
export default CheckoutProvider;